import { render, staticRenderFns } from "./BlogIntroduction.vue?vue&type=template&id=920b244e&scoped=true"
import script from "./BlogIntroduction.vue?vue&type=script&lang=js"
export * from "./BlogIntroduction.vue?vue&type=script&lang=js"
import style0 from "./BlogIntroduction.vue?vue&type=style&index=0&id=920b244e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920b244e",
  null
  
)

export default component.exports